import type { Option } from '@ksyos/design-system';

export const weeksOptions: Option[] = Array.from({ length: 20 }, (_, i) => String(i + 1)).map((value) => ({
    label: value,
    value: value,
}));
